import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { EmojiIcon } from '../EmojiIcon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './StartSlideV15.css';

const cx = classnames.bind(styles);

const STEPS = [
    { title: 'The Thickness', icon: 'books', isActive: true },
    { title: 'The Genre', icon: 'performing-arts', isActive: false },
    { title: 'The Heat', icon: 'hot-pepper', isActive: false }
];

function StartSlideV15({ id, onContinue, spriteVersion }) {
    const handleStart = () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label: 'Start' });
        onContinue();
    };

    return (
        <section className={styles.form} key={id}>
            <p className={styles.eyebrow}>2-minute test</p>
            <h1 className={styles.heading}>Could your life fill a book?</h1>
            <p className={styles.lead}>Let’s find out which one.</p>
            <p className={styles.subheading}>Take the quiz to personalize your subscription</p>
            <ul className={styles.steps}>
                {STEPS.map(step => (
                    <li key={step.title} className={cx('step', { active: step.isActive })}>
                        <span className={styles.stepIcon}>
                            <EmojiIcon name={step.icon} version={spriteVersion} />
                        </span>
                        <span className={styles.stepTitle}>{step.title}</span>
                        {step.isActive ? (
                            <span className={styles.badge}>Up next</span>
                        ) : (
                            <span className={styles.status}>Waiting</span>
                        )}
                    </li>
                ))}
            </ul>
            <Button
                type='berry'
                label='Start'
                onClick={handleStart}
                className={styles.button}
                inSlide
            />
        </section>
    );
}

StartSlideV15.propTypes = {
    id: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired,
    spriteVersion: PropTypes.string.isRequired
};

export {
    StartSlideV15
};
